/**
 * Ce que l'application exige d'un mot de passe, dit à l'utilisateur.
 *
 * ── Pourquoi ici, et une seule fois ─────────────────────────────────────────
 * Trois écrans posent un mot de passe — inscription, réinitialisation, mise en
 * service d'un compte créé par l'école — et chacun portait sa propre phrase et
 * sa propre constante. Durcir la règle oblige alors à les retrouver toutes ;
 * celle qu'on oublie annonce une exigence périmée, et l'utilisateur se voit
 * refuser un mot de passe qui respecte pourtant ce qu'on lui a demandé.
 *
 * La règle elle-même vit sur le SERVEUR (`politiqueMotDePasse`) : lui seul
 * refuse. Ce qui suit n'est que son énoncé — l'annoncer d'avance évite un
 * aller-retour, mais ne remplace rien.
 */

export const LONGUEUR_MINIMALE_MOT_DE_PASSE = 12;

/** Énoncé complet, pour l'aide sous le champ. */
export const AIDE_MOT_DE_PASSE =
  `Au moins ${LONGUEUR_MINIMALE_MOT_DE_PASSE} caractères, `
  + 'dont une minuscule, une majuscule et un caractère spécial.';
